import React from 'react';
import { Grid } from '~/components';
import { DateTime } from 'luxon';
import './ResultsGrid.css';
import { sortDates, sortStrings } from '~/util/sorters';

const AddressCell = ({data, ...rest}) => {
    const { address, city, state, zipcode } = data;


    return (
        <span {...rest}>
            {address}, {city}, {state} {zipcode}
        </span>
    );
};

const DateCell = (fieldName) => ({data}) => {
    const value = data[fieldName];

    if (!value)
        return (<></>);

    const parsed = DateTime.fromJSDate(new Date(value));

    return (
        `${parsed.toLocaleString()}`
    );
};

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 pr-4 border-b'
};

const ResultGrid = ({results, events, isComplete = false, initialState, className}) => {
    const columns = [
        { 
            title: 'Order No', 
            field: 'orderNo',
            headerClassName,
            props
        },
        { 
            title: 'Owner Name', 
            field: 'buyer',
            headerClassName,
            props
        },
        {
            title: 'Address',
            cell: AddressCell,
            sorter: (a,b) => {
                return sortStrings(
                    `${a.address}, ${a.city}, ${a.state} ${a.zipcode}`,
                    `${b.address}, ${b.city}, ${b.state} ${b.zipcode}`
                );
            },
            headerClassName,
            props
        },
        {
            title: 'County',
            field: 'county',
            headerClassName,
            props
        },
        {
            title: 'Lender Policy Date',
            cell: DateCell('lenderPolicyDate'),
            sorter: (a,b) => sortDates(a.lenderPolicyDate, b.lenderPolicyDate),
            headerClassName,
            props
        },
        {
            title: 'Owner Policy Date',
            cell: DateCell('ownerPolicyDate'),
            sorter: (a,b) => sortDates(a.ownerPolicyDate, b.ownerPolicyDate),
            headerClassName,
            props
        },
        {
            title: 'Source System',
            field: 'foundIn',
            headerClassName,
            props
        }
    ];

    return (
        <div className={className}>
            <Grid 
                className='w-full'
                rowSelect={!isComplete}
                data={results}
                columns={columns}
                events={events}
                initialState={initialState}
            />            
        </div>  
    );
};

export default ResultGrid;